module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "visual-line"
    }
  }, [_c('ul', {
    staticClass: "holder"
  }, [_c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("Размер шрифта")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "visual-font-size"
    }
  }, [_c('li', {
    staticClass: "n",
    class: {
      'active': _vm.fontSize == 'n'
    },
    on: {
      "click": function($event) {
        return _vm.setFontSizeChange('n')
      }
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('li', {
    staticClass: "b",
    class: {
      'active': _vm.fontSize == 'font-size-b'
    },
    attrs: {
      "data-class": "font-size-b"
    },
    on: {
      "click": function($event) {
        return _vm.setFontSizeChange('font-size-b')
      }
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('li', {
    staticClass: "vb",
    class: {
      'active': _vm.fontSize == 'font-size-vb'
    },
    attrs: {
      "data-class": "font-size-vb"
    },
    on: {
      "click": function($event) {
        return _vm.setFontSizeChange('font-size-vb')
      }
    }
  }, [_vm._v("A")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("Изображения")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "visual-images"
    }
  }, [_c('li', {
    staticClass: "on",
    class: {
      'active': _vm.showImages
    },
    on: {
      "click": function($event) {
        return _vm.showImagesChange(true)
      }
    }
  }, [_vm._v("Вкл")]), _vm._v(" "), _c('li', {
    staticClass: "off",
    class: {
      'active': !_vm.showImages
    },
    attrs: {
      "data-class": "images-off"
    },
    on: {
      "click": function($event) {
        return _vm.showImagesChange(false)
      }
    }
  }, [_vm._v("Выкл")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "label"
  }, [_vm._v("Цвет фона")]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "visual-color"
    }
  }, [_c('li', {
    staticClass: "n",
    class: {
      'active': _vm.fontColor == 'white'
    },
    on: {
      "click": function($event) {
        return _vm.setFontColorChange('white')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "bw",
    class: {
      'active': _vm.fontColor == 'color-bw'
    },
    attrs: {
      "data-class": "color-bw"
    },
    on: {
      "click": function($event) {
        return _vm.setFontColorChange('color-bw')
      }
    }
  }), _vm._v(" "), _c('li', {
    staticClass: "bg",
    class: {
      'active': _vm.fontColor == 'color-bg'
    },
    attrs: {
      "data-class": "color-bg"
    },
    on: {
      "click": function($event) {
        return _vm.setFontColorChange('color-bg')
      }
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-162d627b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VVisually.vue
// module id = 12
// module chunks = 1 2 3 4 5 6 7 8